export default __webpack_public_path__ + "static/media/armorripper3.f7086404.png";